import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sticky mb-auto top-18 md:self-start shadow-elevation card card-filled" }
const _hoisted_2 = {
  key: 0,
  class: "mb-2 -mx-5 -mt-4 text-sm rounded-b-none banner banner-danger"
}
const _hoisted_3 = { class: "flex items-center mx-auto space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "my-auto text-base material-icons-outlined" }, "pending_actions", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 1,
  class: "w-full"
}
const _hoisted_7 = { class: "flex items-center w-full transition-opacity duration-100" }
const _hoisted_8 = {
  key: 0,
  class: "mr-auto text-muted"
}
const _hoisted_9 = { class: "mr-1" }
const _hoisted_10 = { class: "text-lg" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-lg" }
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 2,
  class: "flex items-center ml-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg icon-light material-icons" }, "edit", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg icon-light material-icons-outlined" }, "undo", -1)
const _hoisted_17 = { class: "transition-opacity duration-100" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-muted"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-4 mb-2 flex items-center space-x-4 text-muted"
}
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "mt-4 mb-4 flex items-start space-x-2 text-muted text-xs" }
const _hoisted_24 = { class: "opacity-80" }
const _hoisted_25 = {
  style: {"width":"18px","fill":"currentColor"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("title", null, "robot", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", { d: "M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A2.5,2.5 0 0,0 5,15.5A2.5,2.5 0 0,0 7.5,18A2.5,2.5 0 0,0 10,15.5A2.5,2.5 0 0,0 7.5,13M16.5,13A2.5,2.5 0 0,0 14,15.5A2.5,2.5 0 0,0 16.5,18A2.5,2.5 0 0,0 19,15.5A2.5,2.5 0 0,0 16.5,13Z" }, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "ml-0" }
const _hoisted_31 = { class: "flex items-center space-x-2" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "text-xs text-gray-500 mt-2" }
const _hoisted_35 = { class: "mt-4" }
const _hoisted_36 = {
  key: 0,
  class: "mt-4 ml-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_TextEditor = _resolveComponent("TextEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.readOnly && _ctx.assessment.score === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("event_assessment.this_exercise_requires_manual_assessment")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.writeOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.assessment.score !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "scoreTitle")
                  ]),
                  _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.assessment.score), 1),
                  (_ctx.maxScore)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("misc.out_of")) + " ", 1),
                        _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.maxScore ?? 0), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("event_assessment.no_score_for_exercise")), 1)),
            (!_ctx.readOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_Btn, {
                    outline: true,
                    variant: 'icon',
                    size: 'sm',
                    tooltip: _ctx.expanded ? '' : _ctx.$t('help_texts.edit_score'),
                    disabled: _ctx.expanded,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowAssessmentControls()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["tooltip", "disabled"]),
                  (!_ctx.readOnly && _ctx.assessment.score_edited)
                    ? (_openBlock(), _createBlock(_component_Btn, {
                        key: 0,
                        outline: true,
                        class: "ml-auto",
                        variant: 'icon',
                        size: 'sm',
                        tooltip: _ctx.$t('event_assessment.undo_score_edit_tooltip'),
                        disabled: _ctx.expanded,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUndoScoreEdit()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["tooltip", "disabled"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            ((_ctx.assessment.comment?.length ?? 0) > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(!_ctx.readOnly
							? _ctx.$t("event_assessment.comment_for_student")
							: _ctx.$t("misc.teacher_comment")) + ": ", 1))
              : _createCommentVNode("", true),
            (_ctx.runningAiAssessment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_Spinner),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("event_assessment.ai_assessment_in_progress")), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.assessmentCommentIsAiGenerated && !_ctx.runningAiAssessment)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  innerHTML: _ctx.assessment.comment
                }, null, 8, _hoisted_21))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_assessment.ai_generated_comment")), 1)
                  ]),
                  ('steps' in _ctx.parsedAiAssessment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("ul", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedAiAssessment.steps, (step) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: step,
                              class: "my-2"
                            }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_ProcessedTextFragment, {
                                  class: "user-content",
                                  value: step.text
                                }, null, 8, ["value"]),
                                _createElementVNode("p", {
                                  class: _normalizeClass([
											'material-icons mr-1.5 text-base',
											step.correct === 'yes'
												? 'text-success'
												: step.correct === 'partial'
												? 'text-yellow-500'
												: step.correct === 'no'
												? 'text-red-500'
												: 'text-muted',
										])
                                }, _toDisplayString(step.correct === "yes"
												? "check"
												: step.correct === "partial"
												? "remove"
												: step.correct === "no"
												? "close"
												: "help"), 3)
                              ]),
                              _createVNode(_component_ProcessedTextFragment, {
                                value: step.reason
                              }, null, 8, ["value"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ('comment' in _ctx.parsedAiAssessment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.parsedAiAssessment.comment), 1),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.parsedAiAssessment.summary), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{
				'max-h-0': !_ctx.expanded,
				'max-h-96': _ctx.expanded,
			}, "flex flex-col overflow-y-hidden duration-200 ease-in-out transition-max-height"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{
					'md:flex-row  md:items-center': !_ctx.isSubSlot,
					'mt-4': !_ctx.writeOnly,
				}, "flex flex-col ease-in-out"])
      }, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("event_assessment.your_assessment")), 1)
      ], 2),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_NumberInput, {
          class: "mb-4",
          modelValue: _ctx.scoreProxy,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scoreProxy) = $event)),
          max: _ctx.maxScore
        }, {
          rightHint: _withCtx(() => [
            _createTextVNode("/" + _toDisplayString(_ctx.maxScore ?? 0), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.assigned_score")) + " ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "max"]),
        _createVNode(_component_TextEditor, {
          class: "w-full",
          modelValue: _ctx.commentProxy,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.commentProxy) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.comment_for_student")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (!_ctx.writeOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createVNode(_component_Btn, {
              class: "mr-2",
              outline: false,
              variant: 'primary',
              loading: _ctx.loading,
              disabled: _ctx.dirtyScore === null || String(_ctx.dirtyScore ?? '').length === 0,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSave()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.confirm_assessment")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            _createVNode(_component_Btn, {
              outline: true,
              disabled: _ctx.loading,
              variant: 'primary',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onHideAssessmentControls()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("dialog.default_cancel_text")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}